/* Creator landing pages (templates/page.landing-*.liquid): sales attribution, countdown, reviews carousel, offer tiers, mobile sticky bar. */

/* Sales per landing page: every cart permalink (/cart/{variant}:{qty}…, in href or a tier's data-href) gets
   attributes[landing_page]={page handle}, which lands on the order under "Additional details".
   Runs before the offer tiers below copy data-href into the CTA. /cart/add and /cart/clear links are skipped:
   the cocoa subscribe page sets the attribute itself through the Ajax cart. */
(function(){
  var page=document.body.getAttribute('data-landing-page'); if(!page) return;
  var param='attributes%5Blanding_page%5D='+encodeURIComponent(page), PERMALINK=/\/cart\/\d+:\d+/;
  function tag(url){
    if(!url || !PERMALINK.test(url) || url.indexOf('landing_page')>-1) return url;
    var hash=url.indexOf('#'), tail=hash>-1 ? url.slice(hash) : ''; if(hash>-1) url=url.slice(0,hash);
    return url+(url.indexOf('?')>-1 ? '&' : '?')+param+tail;
  }
  [].forEach.call(document.querySelectorAll('a[href*="/cart/"]'),function(a){ a.setAttribute('href',tag(a.getAttribute('href'))); });
  [].forEach.call(document.querySelectorAll('[data-href*="/cart/"]'),function(el){ el.setAttribute('data-href',tag(el.getAttribute('data-href'))); });
})();

/* Per-visitor 48-hour countdown (Ale 2026-09-25): starts the first time a visitor lands on this page,
   saved in localStorage (key from the banner's data-deal-key) so a refresh or a return visit keeps counting down.
   Same browser only: a new device / private window starts its own 48h. If storage is blocked, it starts at page load.
   Always visible; when a cycle hits 0 it restarts at 48:00:00 (never ends). */
(function () {
  var DEAL_HOURS = 48;
  var banner = document.querySelector('.sticky-banner[data-deal-key]');
  var timer = document.getElementById('sb-timer'), fallback = document.getElementById('sb-fallback');
  if (!banner || !timer) return;
  var key = banner.getAttribute('data-deal-key'), start = Date.now();
  try {
    var saved = parseInt(localStorage.getItem(key), 10);
    if (saved && saved <= Date.now()) { start = saved; } else { localStorage.setItem(key, String(start)); }
  } catch (e) {}
  var h = document.getElementById('sb-h'), m = document.getElementById('sb-m'), sec = document.getElementById('sb-s');
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var period = DEAL_HOURS * 3600;
    var elapsed = Math.floor((Date.now() - start) / 1000);
    var left = period - (((elapsed % period) + period) % period);
    if (isNaN(left) || left <= 0) left = period;
    timer.style.display = 'flex'; fallback.style.display = 'none';
    h.textContent = pad(Math.floor(left / 3600));
    m.textContent = pad(Math.floor(left % 3600 / 60));
    sec.textContent = pad(left % 60);
    setTimeout(tick, 1000);
  }
  tick();
})();

/* Reviews carousel */
(function(){
  var t=document.getElementById('rvTrack'); if(!t) return;
  var prev=document.querySelector('.rv-prev'), next=document.querySelector('.rv-next'), dotsEl=document.getElementById('rvDots');
  var cards=t.querySelectorAll('.rv-card');
  function step(){ var c=cards[0]; return c ? c.getBoundingClientRect().width+18 : 300; }
  function perView(){ return Math.max(1, Math.round(t.clientWidth/step())); }
  function pages(){ return Math.max(1, Math.ceil((cards.length-perView())/perView())+1); }
  function build(){ dotsEl.innerHTML=''; for(var i=0;i<pages();i++){ var b=document.createElement('button'); b.setAttribute('aria-label','Reviews page '+(i+1)); (function(i){ b.onclick=function(){ t.scrollTo({left:i*perView()*step(),behavior:'smooth'}); }; })(i); dotsEl.appendChild(b);} update(); }
  function update(){ var max=t.scrollWidth-t.clientWidth-4; prev.disabled=t.scrollLeft<4; next.disabled=t.scrollLeft>=max;
    var p=Math.min(pages()-1, Math.round(t.scrollLeft/(perView()*step()))); if(t.scrollLeft>=max) p=pages()-1;
    [].forEach.call(dotsEl.children,function(d,i){ d.classList.toggle('on',i===p); }); }
  prev.onclick=function(){ t.scrollBy({left:-perView()*step(),behavior:'smooth'}); };
  next.onclick=function(){ t.scrollBy({left:perView()*step(),behavior:'smooth'}); };
  t.addEventListener('scroll',function(){ window.requestAnimationFrame(update); },{passive:true});
  window.addEventListener('resize',build); build();
})();

/* Offer box tiers. Each tier <input> carries its image (data-img) and cart link (data-href).
   The CTA's data-label and the image's data-alt are templates where {n} is the tier and {next} is tier + 1
   (for "Buy n, Get n+1 Free" offers).
   A page can have two offer boxes (V2 A/B: top + #buy); they stay on the same tier.
   The first box's data-default-tier picks the tier selected on load (default: 2). */
(function(){
  var boxes=[].slice.call(document.querySelectorAll('.ob')); if(!boxes.length) return;
  [1,2,3].forEach(function(n){ var i=boxes[0].querySelector('input[value="'+n+'"]'); if(i){ var p=new Image(); p.src=i.getAttribute('data-img'); } }); /* preload so the swap is instant */
  function fill(tpl,n){ return (tpl||'').replace(/\{n\}/g,n).replace(/\{next\}/g,n+1); }
  function render(n){ n=+n;
    boxes.forEach(function(ob){
      var i=ob.querySelector('.ob-tier input[value="'+n+'"]'), img=ob.querySelector('.ob-visual img'), cta=ob.querySelector('.ob-cta'), ctaTxt=cta&&cta.querySelector('span');
      if(!i) return; i.checked=true;
      if(img){ img.src=i.getAttribute('data-img'); img.alt=fill(img.getAttribute('data-alt'),n); }
      if(ctaTxt) ctaTxt.textContent=fill(cta.getAttribute('data-label'),n);
      if(cta){ cta.setAttribute('data-tier',n); cta.href=i.getAttribute('data-href'); }
      [].forEach.call(ob.querySelectorAll('.ob-tier'),function(l){ l.classList.toggle('on', l.querySelector('input').value==n); });
    });
  }
  boxes.forEach(function(ob){ [].forEach.call(ob.querySelectorAll('.ob-tier input'),function(i){ i.addEventListener('change',function(){ render(this.value); }); }); });
  render(boxes[0].getAttribute('data-default-tier') || 2);
})();

/* Mobile sticky buy bar: hidden while the hero CTA (or the V2 top offer box), the #buy offer or the closing CTA is on screen */
(function(){
  var bar=document.getElementById('stickyBuy'); if(!bar||!('IntersectionObserver' in window)) return;
  var heroBtn=document.querySelector('.hero-section .btn-red') || document.querySelector('.offer-top .ob'), offer=document.querySelector('#buy .ob'), closing=document.querySelector('.closing-cta .btn-red');
  var st={hero:true,offer:false,closing:false};
  function upd(){ var show=!st.hero && !st.offer && !st.closing; bar.classList.toggle('on',show); bar.setAttribute('aria-hidden',show?'false':'true'); }
  function watch(el,key){ if(!el) return; new IntersectionObserver(function(e){ st[key]=e[0].isIntersecting; upd(); }).observe(el); }
  watch(heroBtn,'hero'); watch(offer,'offer'); watch(closing,'closing');
})();
